import { Box, Button } from '@mui/material'
import {
  OpenInNew as OpenInNewIcon,
  Description as DocumentIcon
} from '@mui/icons-material'
import { _ENV_VARIABLES } from '@/utils/constants'

interface QuickLinksProps {
  loadId: string
  disabled?: boolean
}

/**
 * Quick action links for the load
 * - Open in Bridge18 (load tab)
 * - View Documents (document tab)
 */
const QuickLinks = ({ loadId, disabled = false }: QuickLinksProps) => {
  const baseUrl = `${_ENV_VARIABLES.B18_APP_URL}/dashboard/load/${loadId}/edit`

  const handleOpenInB18 = () => {
    window.open(`${baseUrl}?tab=load`, '_blank', 'noopener,noreferrer')
  }

  const handleViewDocuments = () => {
    window.open(`${baseUrl}?tab=document`, '_blank', 'noopener,noreferrer')
  }

  return (
    <Box sx={{ display: 'flex', gap: 1 }}>
      <Button
        fullWidth
        variant="outlined"
        onClick={handleViewDocuments}
        disabled={disabled || !loadId}
        startIcon={<DocumentIcon fontSize="small" />}
        sx={{
          py: 1,
          borderRadius: 1.5,
          fontWeight: 600,
          fontSize: '0.8rem',
          textTransform: 'none'
        }}
      >
        Documents
      </Button>
      <Button
        fullWidth
        variant="contained"
        onClick={handleOpenInB18}
        disabled={disabled || !loadId}
        endIcon={<OpenInNewIcon fontSize="small" />}
        sx={{
          py: 1,
          borderRadius: 1.5,
          fontWeight: 600,
          fontSize: '0.8rem',
          textTransform: 'none',
          boxShadow: 2,
          '&:hover': {
            boxShadow: 4
          }
        }}
      >
        Open in B18
      </Button>
    </Box>
  )
}

export default QuickLinks
